import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import ServiceCard from '../ServiceCard/ServiceCard';
import './ServiceCarousel.css';

// Import Swiper styles
import 'swiper/swiper.min.css';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';

// Install modules
SwiperCore.use([Navigation, Pagination, Autoplay]);

const ServiceCarousel = ({ services, onServiceClick, onSystemClick }) => {
    return (
        <div style={{ width: '100%', padding: '20px 0' }}>
            <Swiper
                spaceBetween={30}
                slidesPerView={1}
                centeredSlides={false}
                loop={services.length + 1 > 3}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                pagination={{
                    clickable: true,
                    dynamicBullets: true,
                }}
                navigation={true}
                breakpoints={{
                    640: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 2,
                    },
                    1024: {
                        slidesPerView: 3,
                    },
                }}
                style={{
                    padding: '20px 0 50px 0',
                    overflow: 'hidden'
                }}
            >
                {services.map((direction, index) => (
                    <SwiperSlide key={direction.id || index}>
                        <ServiceCard
                            cardNumber={index}
                            title={direction.name || direction.title}
                            bodyText={direction.description || direction.bodyText}
                            onRequestPress={() => onServiceClick(direction)}
                        />
                    </SwiperSlide>
                ))}
                {/* Manual SIT Card */}
                <SwiperSlide>
                    <ServiceCard
                        cardNumber={3}
                        title={"Sistema de Seguimiento a la Inversión Turística"}
                        bodyText={
                            "En este sistema se registra la inversión mensual de los proyectos, la cual le permite enviar los listados de exoneraciones para su aprobación."
                        }
                        requestCustomTitle="VER SISTEMA"
                        onRequestPress={onSystemClick}
                    />
                </SwiperSlide>
            </Swiper>
        </div>
    );
};

export default ServiceCarousel;
